import WorkshopFeedbackPopupBlock from './WorkshopFeedbackPopupBlock';

export default WorkshopFeedbackPopupBlock;
